import React from 'react';
import { CharterBooking } from '../HomeComponents/CharterBooking';
import { OurLuxuryHeader } from '../HomeComponents/OurLuxuryHeader';

export const OurLuxurySection = () => {
  return (
    <section className="ourluxursection">
       <OurLuxuryHeader />
        <CharterBooking />
    </section>
  );
};
